import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClient3 = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  patient: null,
  errorStatus: null,
  addPatient: null,
  patientSimpleData: null,
  patientSimpleDataReport: null,
  listModificationsPatients: null,
  file: null,
  attachment: [],
};
const getters = {
  getApiLoad_60: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Patient(state, patient) {
    state.patient = patient;
  },
  SET_AddPatient(state, patient) {
    state.addPatient = patient;
  },
  SET_PatientById(state, patient) {
    state.patientSimpleData = patient;
  },
  SET_PatientByIdReport(state, patient) {
    state.patientSimpleDataReport = patient;
  },
  SET_ModificationsPatients(state, patient) {
    state.listModificationsPatients = patient;
  },
  SET_File(state, data) {
    state.file = data;
  },
  SET_Attachment(state, data) {
    state.attachment = data;
  },
};
const actions = {
  errorPatient({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getPatientWithDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/ByIdWithDetails?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Patient', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  getPatientById({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/ById?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PatientById', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  getModificationsPatients({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/Modifications?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ModificationsPatients', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  getPatientForEditReport({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/ForEdit?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PatientByIdReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  setPatientForEditReport({ commit, dispatch, rootState }, data) {
    return apiClient3
      .post('Patients/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  modificationAttachmentPatient({ commit, dispatch, rootState }, data) {
    return apiClient3
      .post('/Patients/ModificationAttachment', data,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  downloadModificationAttachment({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/ModificationAttachment?id=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        responseType: 'blob',
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_File', response.data);
      })
      .catch(async (error) => {
        await dispatch('errorCall', error);
      });
  },
  addPatient({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Patients', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AddPatient', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  deletePatient({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Patients/Remove?patientId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
  getPatientAttachment({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Patients/Attachments?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Attachment', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatient', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
